import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';
import { Environment } from '../../../environment';

const getAll = async (): Promise<any[] | ApiException> => {
  try {
    const { data } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/TiposContainer`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    if (data) {
      return data as any[];
    } else {
      return new ApiException('Não foi possível consultar os containers');
    }
  } catch (error: any) {
    console.error('Erro ao consultar containers:', error);
    return new ApiException(
      error.data.data.erro || 'Erro ao consultar containers.'
    );
  }
};

export const ContainerService = {
  getAll,
};
